<cap-list-loader
  [defaultText]="'gemaessAmtlicherBewertung'"
  [hasRight]="hasRight"
  [listLoader]="listLoader"
  [showTotal]="false"
  class="externe-daten">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>{{ "Eigentum" | translate }}</th>
    <th>{{ "KantonalePersonenID" | translate }}</th>
    <th>{{ "Anteil" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    @if (item) {
      <ng-template [ngTemplateOutlet]="personTemplate" [ngTemplateOutletContext]="{ person: item, odd: odd }"></ng-template>
    }
  }
</ng-template>

<ng-template #personTemplate let-odd="odd" let-person="person">
  <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
    <td>
      <div [style.padding-left.px]="person.object.level * 10">
        {{ person.object.gesamthandVerhaeltnis }}
        @if (person.zentralePerson) {
          <span>
            {{ person.zentralePerson.bezeichnung }}
            <div>
              @if (person.zentralePerson?.adressen[0]) {
                <cap-kompakt-personenadresse
                  [entry]="person.zentralePerson"
                  [item]="person.zentralePerson?.adressen[0]"></cap-kompakt-personenadresse>
              }
            </div>
          </span>
        }
        {{ person.object.eigentumForm }}
      </div>
    </td>
    <td>
      @if (person.zentralePerson?.fremdId) {
        <cap-link
          [params]="[person.zentralePerson?.fremdId]"
          [target]="navTargets.NAV_PERSON_ZPV"
          [tooltipParams]="{ person: person.zentralePerson.bezeichnung }">
          <span>
            {{ person.zentralePerson.fremdId }}
          </span>
        </cap-link>
      }
    </td>
    <td>
      @if (
        person.object.anteilZaehler &&
        person.object.anteilZaehler !== "0" &&
        !(person.object.anteilZaehler === "1" && person.object.anteilNenner === "1")
      ) {
        <span> {{ person.object.anteilZaehler | decimalHochkomma }} /{{ person.object.anteilNenner | decimalHochkomma }} </span>
      }
    </td>
  </tr>

  @for (mitglieder of person?.mitgliederVm; track mitglieder) {
    <ng-template [ngTemplateOutlet]="personTemplate" [ngTemplateOutletContext]="{ person: mitglieder, odd: odd }"></ng-template>
  }
</ng-template>
